import { useInfiniteQuery } from 'react-query';
import { Components } from '../../../global.d';
import PendingClosingService from '../../../services/PendingClosingService';
import { LIST } from '../../constants/queryDefinition';
import { TradeContext } from '../../types/trade';

export type PendingRequest = Components.Schemas.PendingRequest;

const queryQueyMap: any = {
  [TradeContext.Buy]: [
    LIST.BUYPENDING.DECISION.KEY,
    LIST.BUYPENDING.NEGOTIATION.KEY
  ],
  [TradeContext.Sell]: [
    LIST.SELLPENDING.DECISION.KEY,
    LIST.SELLPENDING.NEGOTIATION.KEY
  ]
};

const getBuyPending = ({ queryKey }) => {
  const [, request] = queryKey;
  return PendingClosingService.getBuyPending(request);
};

const getSellPending = ({ queryKey }) => {
  const [, request] = queryKey;
  return PendingClosingService.getSellPending(request);
};

export default function useTradeListPendingList(
  request: PendingRequest,
  tradeContext: TradeContext.Buy | TradeContext.Sell
) {
  const queryFn =
    tradeContext === TradeContext.Buy ? getBuyPending : getSellPending;
  if (request.sellingNetworkId === 'all') {
    request.sellingNetworkId = undefined;
  }

  return useInfiniteQuery(
    tradeContext
      ? [queryQueyMap[tradeContext][request?.hasNegotiation ? 1 : 0], request]
      : 'pendingList-undefined',
    async ({
      queryKey,
      pageParam = {
        offset: request.offset
      }
    }) => queryFn({ queryKey }),
    {
      getNextPageParam: page =>
        page.offset + page.size >= page.totalResult
          ? undefined
          : { ...request, offset: page.offset + page.size },
      getPreviousPageParam: page =>
        page.offset < page.size
          ? undefined
          : { ...request, offset: page.offset - page.size },
      refetchOnMount: 'always',
      enabled: Boolean(tradeContext)
    }
  );
}
